import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Slide,
  Grid,
  IconButton,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box,
  Paper,
  Chip,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import getArticleService from "../../../../services/getArticleService";
import CloseIcon from "@mui/icons-material/Close";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import ImageIcon from "@mui/icons-material/Image";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import PendingIcon from "@mui/icons-material/Pending";
import moment from "moment";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const ViewPaymentProof = ({ setIsOpenView, isOpenView, articleData }) => {
  const [preSignedUrls, setPreSignedUrls] = useState({});
  const [selectedImage, setSelectedImage] = useState(null);
  const [openImageDialog, setOpenImageDialog] = useState(false);
  const [openPdfDialog, setOpenPdfDialog] = useState(false);
  const [selectedPdf, setSelectedPdf] = useState(null);

  useEffect(() => {
    console.log(
      "ViewPaymentProof mounted/updated with articleData:",
      articleData
    );
    if (articleData?.payments) {
      console.log("Payments data:", articleData.payments);
      console.log("Payments array:", articleData.payments.L);
    }
  }, [articleData]);

  const handleClose = () => {
    setIsOpenView(false);
    setPreSignedUrls({});
  };

  const handleImageClick = (fileKey) => {
    // Check if the file is a PDF
    if (fileKey.toLowerCase().endsWith(".pdf")) {
      setSelectedPdf(fileKey);
      setOpenPdfDialog(true);
    } else {
      setSelectedImage(fileKey);
      setOpenImageDialog(true);
    }
  };

  const handlePdfClick = (pdfKey) => {
    setSelectedPdf(pdfKey);
    setOpenPdfDialog(true);
  };

  const handleCloseImageDialog = () => {
    setOpenImageDialog(false);
    setSelectedImage(null);
  };

  const handleClosePdfDialog = () => {
    setOpenPdfDialog(false);
    setSelectedPdf(null);
  };

  const fetchData = async () => {
    console.log("Fetching data for articleData:", articleData);
    console.log("Payments array:", articleData?.payments);

    if (!articleData?.payments || !Array.isArray(articleData.payments)) {
      console.log("No valid payments data found");
      return;
    }

    const urls = {};
    const payments = articleData.payments;
    console.log("Processing payments:", payments);

    for (const payment of payments) {
      console.log("Processing payment:", payment);

      // Fetch invoice PDF URL if exists
      if (payment.invoiceKey) {
        try {
          console.log("Fetching invoice URL for:", payment.invoiceKey);
          const data = await getArticleService.getFilePreSIgnedUrl({
            key: payment.invoiceKey,
          });
          urls[payment.invoiceKey] = data;
        } catch (error) {
          console.error("Error fetching PDF URL:", error);
        }
      }

      // Fetch payment proof image URLs
      if (
        payment.paymentProofFileKeys &&
        Array.isArray(payment.paymentProofFileKeys)
      ) {
        console.log("Processing payment proofs:", payment.paymentProofFileKeys);
        for (const proof of payment.paymentProofFileKeys) {
          try {
            console.log("Fetching proof URL for:", proof);
            const data = await getArticleService.getFilePreSIgnedUrl({
              key: proof,
            });
            urls[proof] = data;
          } catch (error) {
            console.error("Error fetching image URL:", error);
          }
        }
      }
    }
    console.log("Generated URLs:", urls);
    setPreSignedUrls(urls);
  };

  useEffect(() => {
    if (articleData?.payments && Array.isArray(articleData.payments)) {
      console.log("Triggering fetchData for payments");
      fetchData();
    }
  }, [articleData?.payments]);

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  const getPaymentStatus = (utrNo) => {
    if (utrNo && utrNo.trim() !== "") {
      return {
        label: "Payment Confirmed",
        color: "success",
        icon: <CheckCircleIcon />,
      };
    }
    return {
      label: "Payment Pending",
      color: "warning",
      icon: <PendingIcon />,
    };
  };

  return (
    <>
      <Dialog
        open={isOpenView}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        fullWidth={true}
        maxWidth={"md"}
      >
        <DialogTitle className="pt-3 modal_header_dealog">
          Payment History
        </DialogTitle>

        <DialogContent>
          {articleData?.payments && Array.isArray(articleData.payments) ? (
            <Box sx={{ mt: 2 }}>
              {articleData.payments.map((payment, index) => {
                const status = getPaymentStatus(payment.utrNo);
                return (
                  <Accordion key={payment.paymentId} sx={{ mb: 2 }}>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      sx={{
                        backgroundColor: "background.paper",
                        "&:hover": {
                          backgroundColor: "action.hover",
                        },
                      }}
                    >
                      <Grid container alignItems="center" spacing={2}>
                        <Grid item xs={12} sm={3}>
                          <Typography variant="subtitle1">
                            Payment #{index + 1}
                          </Typography>
                        </Grid>
                        <Grid item xs={12} sm={3}>
                          <Typography variant="body2" color="text.secondary">
                            {formatDate(payment.paymentDate)}
                          </Typography>
                        </Grid>
                        <Grid item xs={12} sm={3}>
                          <Typography variant="subtitle1" color="primary">
                            {payment.amount}
                          </Typography>
                        </Grid>
                        <Grid item xs={12} sm={3}>
                          <Chip
                            icon={status.icon}
                            label={status.label}
                            color={status.color}
                            size="small"
                            sx={{ minWidth: "120px" }}
                          />
                        </Grid>
                      </Grid>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Grid container spacing={2}>
                        <Grid item xs={12}>
                          <Typography variant="subtitle2" gutterBottom>
                            Payment Details
                          </Typography>
                          <Paper
                            elevation={0}
                            sx={{ p: 2, bgcolor: "background.default" }}
                          >
                            <Grid container spacing={2}>
                              <Grid item xs={12} sm={6}>
                                <Typography
                                  variant="body2"
                                  color="text.secondary"
                                >
                                  Amount: {payment.amount}
                                </Typography>
                              </Grid>
                              <Grid item xs={12} sm={6}>
                                <Typography
                                  variant="body2"
                                  color="text.secondary"
                                >
                                  Date: {formatDate(payment.paymentDate)}
                                </Typography>
                              </Grid>
                              <Grid item xs={12} sm={6}>
                                <Typography
                                  variant="body2"
                                  color="text.secondary"
                                >
                                  UTR Number: {payment.utrNo || "Not provided"}
                                </Typography>
                              </Grid>
                              <Grid item xs={12} sm={6}>
                                <Typography
                                  variant="body2"
                                  color="text.secondary"
                                >
                                  Credit Date:{" "}
                                  {payment.creditDate
                                    ? formatDate(payment.creditDate)
                                    : "Not provided"}
                                </Typography>
                              </Grid>
                              <Grid item xs={12} sm={6}>
                                <Typography
                                  variant="body2"
                                  color="text.secondary"
                                >
                                  Payment Mode:{" "}
                                  {payment.paymentMode || "Not provided"}
                                </Typography>
                              </Grid>
                              <Grid item xs={12} sm={6}>
                                <Typography
                                  variant="body2"
                                  color="text.secondary"
                                >
                                  Bank: {payment.bank || "Not provided"}
                                </Typography>
                              </Grid>
                              <Grid item xs={12} sm={6}>
                                <Typography
                                  variant="body2"
                                  color="text.secondary"
                                >
                                  Created At: {payment.createdAtDate ? moment(payment.createdAtDate).format("DD-MM-YY hh:mm A") : "Not provided"}
                                </Typography>
                              </Grid>
                              {payment.remark && (
                                <Grid item xs={12}>
                                  <Typography
                                    variant="body2"
                                    color="text.secondary"
                                  >
                                    Remark: {payment.remark}
                                  </Typography>
                                </Grid>
                              )}
                            </Grid>
                          </Paper>
                        </Grid>

                        {/* Invoice Section */}
                        {payment.invoiceKey && (
                          <Grid item xs={12}>
                            <Typography variant="subtitle2" gutterBottom>
                              Invoice
                            </Typography>
                            <Button
                              variant="outlined"
                              startIcon={<PictureAsPdfIcon />}
                              onClick={() => handlePdfClick(payment.invoiceKey)}
                              sx={{ mb: 2 }}
                            >
                              View Invoice
                            </Button>
                          </Grid>
                        )}

                        {/* Payment Proofs Section */}
                        {payment.paymentProofFileKeys &&
                          payment.paymentProofFileKeys.length > 0 && (
                            <Grid item xs={12}>
                              <Typography variant="subtitle2" gutterBottom>
                                Payment Proofs
                              </Typography>
                              <Grid container spacing={2}>
                                {payment.paymentProofFileKeys.map(
                                  (proof, proofIndex) => {
                                    const isPdf = proof
                                      .toLowerCase()
                                      .endsWith(".pdf");
                                    return (
                                      <Grid
                                        item
                                        key={proofIndex}
                                        xs={6}
                                        sm={4}
                                        md={3}
                                      >
                                        <Paper
                                          elevation={0}
                                          sx={{
                                            p: 1,
                                            cursor: "pointer",
                                            "&:hover": {
                                              bgcolor: "action.hover",
                                            },
                                          }}
                                          onClick={() =>
                                            handleImageClick(proof)
                                          }
                                        >
                                          {preSignedUrls[proof] ? (
                                            isPdf ? (
                                              <Box
                                                sx={{
                                                  width: "100%",
                                                  height: "150px",
                                                  display: "flex",
                                                  flexDirection: "column",
                                                  alignItems: "center",
                                                  justifyContent: "center",
                                                  bgcolor: "background.default",
                                                  borderRadius: "4px",
                                                  gap: 1,
                                                }}
                                              >
                                                <PictureAsPdfIcon
                                                  sx={{
                                                    fontSize: 40,
                                                    color: "error.main",
                                                  }}
                                                />
                                                <Typography
                                                  variant="caption"
                                                  color="text.secondary"
                                                >
                                                  PDF Document
                                                </Typography>
                                              </Box>
                                            ) : (
                                              <img
                                                src={preSignedUrls[proof]}
                                                alt={`Payment Proof ${
                                                  proofIndex + 1
                                                }`}
                                                style={{
                                                  width: "100%",
                                                  height: "150px",
                                                  objectFit: "cover",
                                                  borderRadius: "4px",
                                                }}
                                              />
                                            )
                                          ) : (
                                            <Box
                                              sx={{
                                                width: "100%",
                                                height: "150px",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                bgcolor: "background.default",
                                                borderRadius: "4px",
                                              }}
                                            >
                                              {isPdf ? (
                                                <PictureAsPdfIcon />
                                              ) : (
                                                <ImageIcon />
                                              )}
                                            </Box>
                                          )}
                                        </Paper>
                                      </Grid>
                                    );
                                  }
                                )}
                              </Grid>
                            </Grid>
                          )}
                      </Grid>
                    </AccordionDetails>
                  </Accordion>
                );
              })}
            </Box>
          ) : (
            <Typography variant="h6" align="center" sx={{ mt: 3 }}>
              No Payment History Available
            </Typography>
          )}
        </DialogContent>
        <DialogActions className="pb-3">
          <Button variant="contained" color="error" onClick={handleClose}>
            Close
          </Button>
        </DialogActions>
      </Dialog>

      {/* Image Preview Dialog */}
      <Dialog
        open={openImageDialog}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleCloseImageDialog}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 2,
            boxShadow: "0px 0px 20px rgba(0, 0, 0, 0.15)",
          },
        }}
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            borderBottom: "1px solid",
            borderColor: "divider",
            p: 2,
          }}
        >
          Payment Proof
          <IconButton
            aria-label="close"
            onClick={handleCloseImageDialog}
            sx={{
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ p: 2 }}>
          {selectedImage && preSignedUrls[selectedImage] && (
            <img
              src={preSignedUrls[selectedImage]}
              alt="Payment Proof"
              style={{
                width: "100%",
                height: "auto",
                maxHeight: "70vh",
                objectFit: "contain",
                borderRadius: 4,
              }}
            />
          )}
        </DialogContent>
      </Dialog>

      {/* PDF Preview Dialog */}
      <Dialog
        open={openPdfDialog}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClosePdfDialog}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 2,
            boxShadow: "0px 0px 20px rgba(0, 0, 0, 0.15)",
          },
        }}
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            borderBottom: "1px solid",
            borderColor: "divider",
            p: 2,
          }}
        >
          Invoice
          <IconButton
            aria-label="close"
            onClick={handleClosePdfDialog}
            sx={{
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ p: 2, height: "80vh" }}>
          {selectedPdf && preSignedUrls[selectedPdf] && (
            <iframe
              src={preSignedUrls[selectedPdf]}
              style={{
                width: "100%",
                height: "100%",
                border: "none",
                borderRadius: 4,
              }}
              title="Invoice PDF"
            />
          )}
        </DialogContent>
      </Dialog>
    </>
  );
};

export default ViewPaymentProof;
